exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-module__content___1N33J{display:grid;gap:1rem}.index-module__content___1N33J h2{font-weight:400;margin-bottom:.75em}.index-module__content___1N33J .index-module__text___1GQr0{margin-bottom:1.5em;font-size:18px}.index-module__content___1N33J .index-module__error___1dAMd{padding:1em;background-color:#f1f0ea;color:#707070;border-radius:5px}", ""]);

// exports
exports.locals = {
	"content": "index-module__content___1N33J",
	"text": "index-module__text___1GQr0",
	"error": "index-module__error___1dAMd"
};